<template>
  <div id="edit-section-wrapper">
    <h3 class="edit-section-title">Editar Plantilla</h3>

    <div class="edit-gohome-container">
      <button class="edit-gohome-btn txt-grad-color-2 txt-bold" @click="goHome">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="currentColor"
          class="bi bi-arrow-left"
          viewBox="0 0 16 16"
        >
          <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop
              offset="0%"
              style="stop-color: rgb(0, 246, 187); stop-opacity: 1"
            />
            <stop
              offset="100%"
              style="stop-color: rgb(29, 143, 206); stop-opacity: 1"
            />
          </linearGradient>
          <path
            fill="url(#grad2)"
            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
          />
        </svg>
        Volver al inicio
      </button>
    </div>

    <form class="edit-section-form" @submit.prevent="handleEditionSubmit">
      <div class="edit-input-name-group">
        <label class="edit-name-label txt-bold" for="edit-name">
          Nombre de plantilla:
          <input
            id="edit-name"
            class="edit-name"
            :class="{ 'edit-invalid-input': errors.nameError }"
            type="text"
            v-model="plantilla.nombre"
            @blur="validateName"
            ref="editName"
          />

          <span class="edit-invalid-feedback" v-if="errors.nameFeedback">{{
            errors.nameFeedback
          }}</span>
        </label>

        <label class="edit-cant-label txt-bold" for="edit-cant">
          Cantidad de momentos:
          <input
            id="edit-cant"
            class="edit-cant"
            :class="{ 'edit-invalid-input': errors.momentsError }"
            type="number"
            v-model="plantilla.cantMomentos"
            @blur="validateMoments"
            ref="editCant"
          />

          <span class="edit-invalid-feedback" v-if="errors.momentsFeedback">{{
            errors.momentsFeedback
          }}</span>
        </label>
      </div>

      <div class="edit-weights-input-wrapper">
        <label
          class="edit-weight-label"
          v-for="(moment, index) in intMomentos"
          :for="`edit-weight-${index}`"
          :key="index"
        >
          <span class="txt-grad-azul txt-bold">Momento {{ moment }}</span>

          Peso #{{ moment }}

          <input
            class="edit-weight-input"
            :class="{ 'edit-invalid-input': errors.percentageError }"
            type="number"
            :name="`edit-weight-${index}`"
            :id="`edit-weight-${index}`"
            v-model="plantilla.arrayPorcentajes[index]"
            @keyup="validatePercentage"
            :ref="`editWeight${index}`"
          />
        </label>
      </div>

      <div
        class="edit-invalid-feedback txt-bold"
        v-if="errors.percentageFeedback"
      >
        {{ errors.percentageFeedback }}
      </div>

      <div class="edit-percntgleft-container">
        <label class="edit-percntgleft-label" for="edit-percntgleft">
          <span class="txt-bold txt-grad-azul">% Disponible</span>
          <input
            class="txt-bold"
            id="edit-percntgleft"
            type="text"
            v-model="percentageLeft"
            disabled
          />
        </label>
      </div>

      <div class="edit-btn-container">
        <button class="edit-grad-btn" type="submit">
          <span class="txt-bold">Actualizar</span>
        </button>

        <button
          type="button"
          class="edit-normal-btn txt-bold"
          @click="handleSaveNew"
        >
          Guardar como nueva
        </button>
      </div>
    </form>

    <b-modal
      v-model="modal.show"
      id="edit-modal"
      centered
      :title="modal.title"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="edit-modal-body">
        <p class="edit-modal-txt" v-html="modal.text"></p>
      </div>

      <template #modal-footer>
        <button
          class="edit-modal-normal-btn txt-bold"
          type="button"
          @click="handleCloseModal"
          v-if="modal.footer === 'new'"
        >
          Cancelar
        </button>

        <button
          class="edit-modal-grad-btn"
          type="button"
          @click="saveNew"
          v-if="modal.footer === 'new'"
        >
          <span class="txt-bold">Aceptar</span>
        </button>

        <button
          class="edit-modal-grad-btn"
          type="button"
          @click="goHome"
          v-if="modal.footer === 'update'"
        >
          <span class="txt-bold">Aceptar</span>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      plantilla: {
        nombre: "",
        cantMomentos: "2",
        arrayPorcentajes: [],
      },
      errors: {
        nameFeedback: "",
        nameError: false,
        momentsFeedback: "",
        momentsError: false,
        percentageFeedback: "",
        percentageError: false,
      },
      modal: {
        show: false,
        title: "",
        text: "",
        normalBtnText: "",
        gradBtnText: "",
        footer: "new",
      },
    };
  },

  props: { plantillaEditarProp: Object },

  computed: {
    intMomentos() {
      if (this.errors.momentsError) {
        return 0;
      } else {
        return Number(this.plantilla.cantMomentos);
      }
    },

    percentageLeft() {
      let percentageUsed = 0;

      if (this.plantilla.arrayPorcentajes.length > 0) {
        percentageUsed = this.plantilla.arrayPorcentajes.reduce(
          (acumulado, valorActual) => {
            return Number(acumulado) + Number(valorActual);
          }
        );
      }

      return 100 - percentageUsed;
    },
  },

  mounted() {
    if (
      this.plantillaEditarProp &&
      Object.keys(this.plantillaEditarProp).length > 0
    ) {
      this.plantilla.nombre = this.plantillaEditarProp.plantillaEditar.nombre;
      this.plantilla.cantMomentos =
        this.plantillaEditarProp.plantillaEditar.cantMomentos;
      this.plantilla.arrayPorcentajes =
        this.plantillaEditarProp.plantillaEditar.arrayPorcentajes;
    }
  },

  methods: {
    handleEditionSubmit() {
      if (!this.validateForm()) {
        console.log("Error en validacion");
      } else {
        console.log("Enviado");
        this.modal.title = "Guardado exitosamente";
        this.modal.text = "La plantilla ha sido actualizada exitosamente";
        this.modal.footer = "update";
        this.modal.show = true;
      }
    },

    handleSaveNew() {
      if (!this.validateForm()) {
        console.log("Error en validacion");
      } else {
        this.modal.title = "¿Guardar como nueva?";
        this.modal.text = "¿Deseas guardar esta plantilla como una nueva?";
        this.modal.footer = "new";
        this.modal.show = true;
      }
    },

    saveNew() {
      this.modal.show = false;

      this.modal.title = "Guardado exitosamente";
      this.modal.text = "La plantilla ha sido creada exitosamente";
      this.modal.footer = "update";
      this.modal.show = true;
    },

    validateForm() {
      this.validateName();
      this.validateMoments();
      this.validatePercentage();

      if (
        this.errors.nameError ||
        this.errors.momentsError ||
        this.errors.percentageError
      ) {
        return false;
      } else {
        return true;
      }
    },

    validateName() {
      this.plantilla.nombre = this.plantilla.nombre.trim();

      if (!this.plantilla.nombre) {
        this.focusInput("editName");
        this.errors.nameFeedback = "Debes digitar un nombre para tu plantilla";
        this.errors.nameError = true;
      } else {
        this.errors.nameFeedback = "";
        this.errors.nameError = false;
        this.step++;
      }
    },

    validateMoments() {
      // const numberDecimalRe = /^\d*\.?\d*$/;
      const numberRe = /^\d+$/;
      this.plantilla.cantMomentos = this.plantilla.cantMomentos.trim();

      if (!this.plantilla.cantMomentos) {
        this.focusInput("editCant");
        this.errors.momentsFeedback =
          "Debes digitar la cantidad de momentos a evaluar";
        this.errors.momentsError = true;
      } else if (!numberRe.test(this.plantilla.cantMomentos)) {
        this.focusInput("editCant");
        this.errors.momentsFeedback =
          "Debes digitar un número entero válido entre 1 y 10";
        this.errors.momentsError = true;
      } else if (
        Number(this.plantilla.cantMomentos) <= 0 ||
        Number(this.plantilla.cantMomentos) > 10
      ) {
        this.focusInput("editCant");
        this.errors.momentsFeedback =
          "El número no puede ser mayor a 10 ni tampoco cero";
        this.errors.momentsError = true;
      } else {
        this.errors.momentsFeedback = "";
        this.errors.momentsError = false;
        this.step++;
      }
    },

    validatePercentage() {
      if (this.percentageLeft !== 0) {
        this.errors.percentageFeedback =
          "El total de los momentos debe sumar 100% exacto";
        this.errors.percentageError = true;

        return false;
      } else {
        this.errors.percentageFeedback = "";
        this.errors.percentageError = false;
        return true;
      }
    },

    handleCloseModal() {
      this.modal.show = false;
      this.modal.title = " ";
      this.modal.text = "";
      this.modal.normalBtnText = "";
      this.modal.gradBtnText = "";
    },

    focusInput(inputRef) {
      this.$nextTick(() => {
        this.$refs[inputRef].focus();
      });
    },

    goHome() {
      this.$emit("sectionChange", { section: "home", lastSection: "edit" });
    },
  },
};
</script>

<style>
#edit-section-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.edit-section-title {
  font-size: 40px;
  color: var(--white);
  text-align: center;
}

.edit-gohome-container {
  width: 70%;
  margin: 50px auto 70px auto;
}

.edit-gohome-btn {
  all: unset;
  cursor: pointer;
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
}

.edit-gohome-btn::after {
  content: "";
  position: absolute;
  bottom: -5px;
  width: 0px;
  height: 2px;
  transition: width 0.1s linear;
  background-image: var(--grad-color-2);
  border-radius: 4px;
}

.edit-gohome-btn:focus::after {
  width: 100%;
}

.edit-gohome-btn svg {
  transition: transform 0.3s ease-in-out;
}

.edit-gohome-btn:hover svg {
  transform: translateX(-10px);
}

.edit-section-form {
  margin: 0 auto;
  width: 90%;
  display: flex;
  flex-direction: column;
}

.edit-input-name-group {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

@media screen and(max-width: 1030px) {
  .edit-input-name-group {
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem;
  }
}

.edit-name-label {
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: var(--white);
}

.edit-name {
  outline: none;
  width: 100%;
  height: 48px;
  border-radius: 15px;
  padding: 0 1rem;
}

.edit-cant-label {
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  color: var(--white);
}

.edit-cant {
  outline: none;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  text-align: center;
}

.edit-weights-input-wrapper {
  margin: 70px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 50px;
  text-align: center;
}

.edit-weight-label {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  color: var(--white);
}

.edit-weight-input {
  outline: none;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  text-align: center;
}

.edit-name:focus,
.edit-cant:focus,
.edit-weight-input:focus {
  border: 1px solid var(--accent-color);
  box-shadow: 0 0 0.5rem 1px #49fffcbc;
}

.edit-percntgleft-container {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
}

.edit-percntgleft-label {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

#edit-percntgleft:disabled {
  border: none;
  background-image: var(--grad-color-azul);
  width: 48px;
  height: 48px;
  border-radius: 10px;
  text-align: center;
  color: var(--black);
}

.edit-btn-container {
  margin-top: 1.5rem;
  width: 100%;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
}

.edit-grad-btn {
  outline: none;
  border: none;
  width: 150px;
  height: 48px;
  padding: 2px;
  background-image: var(--grad-color-2);
  border-radius: 15px;
}

.edit-grad-btn span {
  width: 100%;
  height: 100%;
  background-color: var(--black);
  color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 13px;
  transition: background 0.3s ease-in-out;
}

.edit-grad-btn:hover span {
  background-color: transparent;
}

.edit-normal-btn {
  border: none;
  outline: none;
  background-color: transparent;
  height: 48px;
  padding: 0 1rem;
  border-radius: 15px;
  color: var(--white);
  transition: color 0.3s ease-in-out;
}

.edit-normal-btn:hover {
  color: var(--hover-white);
}

.edit-grad-btn:focus,
.edit-normal-btn:focus {
  outline: 1px solid var(--white);
  outline-offset: 2px;
}

.edit-invalid-feedback {
  margin: 0 auto;
  color: red;
  font-size: 14px;
  width: 100%;
  max-width: 300px;
  text-align: center;
}

.edit-invalid-input {
  border: 1px solid red;
}

.edit-invalid-input:focus {
  border: 1px solid red;
  box-shadow: 0 0 1rem 5px #ff5c5cbc;
}

/* ---------------------------------------------- Estilos modal edicion */
#edit-modal {
  font-family: var(--main-font);
}

#edit-modal + .modal-backdrop {
  background: rgba(0, 0, 0, 0.21);
  backdrop-filter: blur(7px);
}

#edit-modal .modal-content {
  background-color: var(--black);
  border: double 1px transparent;
  border-radius: 20px;
  background-image: linear-gradient(var(--black), var(--black)),
    var(--grad-color-2);
  background-origin: border-box;
  background-clip: padding-box, border-box;
}

#edit-modal .modal-header {
  border: none;
}

#edit-modal .modal-header .modal-title {
  width: 100%;
  font-weight: 700;
  text-align: center;
  color: var(--white);
}

#edit-modal .modal-header button {
  display: none;
}

.edit-modal-body {
  width: 100%;
}

.edit-modal-txt {
  text-align: center;
  color: var(--white);
}

#edit-modal .modal-footer {
  border: none;
  justify-content: center;
}

.edit-modal-normal-btn {
  all: unset;
  cursor: pointer;
  width: 150px;
  height: 48px;
  border-radius: 15px;
  color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: color 0.3s ease-in-out;
}

.edit-modal-normal-btn:hover {
  color: var(--hover-white);
}

.edit-modal-grad-btn {
  all: unset;
  cursor: pointer;
  width: 150px;
  height: 48px;
  padding: 2px;
  background-image: var(--grad-color-2);
  border-radius: 15px;
}

.edit-modal-grad-btn span {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--black);
  color: var(--white);
  border-radius: 13px;
  transition: background 0.3s ease-in-out;
}

.edit-modal-grad-btn:hover span {
  background-color: transparent;
}
</style>
